import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import { InputRow, SelectRow } from "../Rows";
import { FormCard } from "../FormCard";
import OcpiModulesList from "./OcpiModulesList";
import { withTranslatedLabels } from "../../i18n/options";

const PartyForm = ({ party,
    handleInputChange,
    isEditing,
    customers = [],
    invalidFields
}) => {
    const { t } = useTranslation();
    const ocpiModules = withTranslatedLabels(
        [
            { label: "Booking", value: "Booking" },
            { label: "Cdrs", value: "cdrs" },
            { label: "Commands", value: "commands" },
            { label: "Credentials", value: "credentials" },
            { label: "Locations", value: "locations" },
            { label: "Sessions", value: "sessions" },
            { label: "Tariffs", value: "tariffs" },
            { label: "Tokens", value: "tokens" },
        ],
        t,
        "ocpiParty.module"
    );
    const [selectedModules, setSelectedModules] = useState([]);

    useEffect(() => {
        if (isEditing && party.modules) {
            setSelectedModules(party.modules.map((m) => m.identifier));
            return;
        }
        if (!isEditing && party.Identifiers !== undefined) {
            setSelectedModules(Array.isArray(party.Identifiers) ? party.Identifiers : []);
        }
    }, [isEditing, party.modules, party.Identifiers]);

    const customerOptions = customers.map((customer) => ({
        value: customer.customerPublicId,
        label: customer.displayName || customer.name,
    }));

    return (
        <>
            <InputRow
                label={t("common.name")}
                value={party.remotePartyName || ""}
                onChange={(v) => handleInputChange("remotePartyName", v)}
            />
            {!isEditing && (
                <SelectRow
                    label={t("entity.customer")}
                    options={customerOptions}
                    value={party.customerPublicId || null}
                    isClearable={true}
                    onChange={(v) => {
                        handleInputChange("customerPublicId", v ?? "");
                    }}
                    invalid={invalidFields?.includes("customerPublicId")}
                />
            )}

            <FormCard
                title={t("form.ocpiModules")}
                className="max-w-3xl !p-5 shadow-md"
                titleClassName="text-lg"
                description={t("ocpiParty.modulesDescription")}
            >
                <OcpiModulesList
                    modules={ocpiModules}
                    selected={selectedModules}
                    disabled={!!isEditing}
                    onChange={(next) => {
                        if (isEditing) {
                            return;
                        }
                        setSelectedModules(next);
                        handleInputChange("Identifiers", next);
                    }}
                />
            </FormCard>
        </>
    );
};

export default PartyForm;
